import type { CIType, CITypeListItem } from '@/entities/srm/ci/@x/tql-query';
import { TQLFilter } from '@/entities/srm/tql-query/model/query';

export const getDisplayName = (
  data: TQLFilter['nodes'][number]['data'],
  cit: CITypeListItem | CIType,
) => (data?.alias ? data.alias : cit ? cit?.label : data?.display_name);